import React from 'react';
import './FooterRoutes.css';

const Disclaimer = () => {
  return (
    <div className="container">
      <h1 className="title">Disclaimer</h1>
      <p>Thank you for visiting us. The following disclaimer outlines the terms and conditions governing your use of our website. By accessing and using our website, you agree to comply with and be bound by the terms outlined in this disclaimer.</p>

      <div className="section">
        <h2 className="subtitle">1. Product Information</h2>
        <ul>
          <li>The information provided on our website, including product descriptions, specifications, and images, is for general informational purposes only.</li>
          <li>While we make every effort to ensure the accuracy of product information, we do not warrant or guarantee the completeness, accuracy, or reliability of any information on our website.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">2. Prescription Eyewear</h2>
        <ul>
          <li>Prescription eyewear products are customized based on the prescription provided by the customer.</li>
          <li>It is the responsibility of the customer to ensure the accuracy of the prescription information provided during the ordering process.</li>
          <li>We recommend consulting with an eye care professional to ensure the accuracy of your prescription.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">3. Colors and Variations</h2>
        <ul>
          <li>Product colors and variations may appear differently on individual screens. We cannot guarantee that the colors and details on your screen will precisely match the actual product.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">4. Third-Party Links</h2>
        <ul>
          <li>Our website may contain links to third-party websites. These links are provided for your convenience and do not signify our endorsement of such websites. We are not responsible for the content or privacy practices of these third-party sites.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">5. Limitation of Liability</h2>
        <ul>
          <li>SpectsGenie, its employees, agents, and affiliates shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of your access, use, or inability to use our website or any errors or omissions in the content.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">6. Changes to the Website and Disclaimer</h2>
        <ul>
          <li>We reserve the right to make changes to our website, policies, and this disclaimer at any time without prior notice.</li>
          <li>It is your responsibility to review this disclaimer periodically for any updates.</li>
        </ul>
      </div>

      <div className="section">
        <h2 className="subtitle">7. Contact Us</h2>
        <p>If you have any questions or concerns regarding this disclaimer, please contact us at <a href="mailto:support@spectsgenie.in">support@spectsgenie.in</a>.</p>
      </div>

      <p><strong>Note:</strong></p>
      <ul>
        <li>This disclaimer is subject to change without notice. Please review this disclaimer periodically for any updates.</li>
        <li>By using our website, you agree to the terms and conditions outlined in this disclaimer.</li>
      </ul>

      <p>Thank you for choosing us. We appreciate your trust and aim to provide you with a positive and reliable online shopping experience.</p>
    </div>
  );
};

export default Disclaimer;
